<template>
  <div class="shadow-setting" :style="{height: collapse ? '46px': type === 'boxShadow' ? '349px' : '309px'}">
    <div class="shadow-setting-header" @click="collapse = !collapse">
      <span>阴影</span>
      <i class="icon icon-set-down" :style="{transform: collapse ? '' : 'rotate(180deg)'}"></i>
    </div>
    <div class="shadow-setting-content">
      <div class="shadow-setting-type">
        <span>类型</span>
        <div class="type-content">
          <ul class="radios__list">
            <li class="radios__item" 
              :class="{active: item.active, disable: item.disable}" 
              v-for="(item, key) in typeList" 
              :key="key"
              @click="selectType(item, key)"
            >
              <i></i>
              <span>{{item.text}}</span>
            </li>
          </ul>
          <el-tooltip effect="dark" content="素材抠图后，设置元素阴影效果更佳" placement="top">
            <div class="shadow-help">?</div>
          </el-tooltip>
        </div>
      </div>
      <div class="shadow-setting-color">
        <span>颜色</span>
        <div class="color-content">
          <div
            :style="{backgroundColor: shadow.color}"
            @click="showColorPicker($event, { whichPart: 'shadow_color' })"
          ></div>
        </div>
      </div>
      <div class="shadow-setting-slider">
        <SliderSetting :list="attr" @changeData="attrChange" />
      </div>
      <div class="shadow-setting-reset">
        <el-button class="reset-button" plain @click="setShadow(true);">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SliderSetting from './sliderSetting.vue'

export default {
  props: {
    updateData: {
      type: Number,
      required: true,
      default: 0
    },
    textShadow: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      collapse: false,
      type: 'boxShadow', // 两种类别
      shadow: {
        x: 0,
        y: 0,
        blur: 0,
        spread: 0,
        color: '#ffffff'
      },
      typeList: [ // 类别选择数组
        {type: 'boxShadow', text: '边框', active: true, disable: false},
        {type: 'dropShadow', text: '元素', active: false}
      ],
      attr: [],
      undoData: null
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectSprites_Msg',
      'SelectScenes_Msg',
    ]),
  },
  watch: {
    'updateData'(val, oldVal) {
      this.initData();
    }
  },
  mounted() {
    this.initData();
    this.$bus.on('colorPickerInput.picker', this.colorPickerInput);
    this.$bus.on("undoRedoHandle", this._undoRedoHandle);
  },
  methods: {
    initData() {
      let s = this.SelectSprites_Msg[0];
      if(this.textShadow) {
        this.typeList[0].disable = true;
        this.selectType(this.typeList[1], 1);
      } else {
        this.typeList[0].disable = false;
      }
      let shadow = s[this.type];
      if(!shadow)
        shadow = {
          x: 0,
          y: 0,
          blur: 0,
          spread: 0,
          color: '#ffffff'
        }

      this.attr = [
        {type: 'x', name: 'X偏移', step: 1, min: -100, max: 100, len: 200, val: shadow.x},
        {type: 'y', name: 'Y偏移', step: 1, min: -100, max: 100, len: 200, val: shadow.y},
        {type: 'blur', name: '模糊', step: 1, min: 0, max: 50, len: 50, val: shadow.blur},
      ]

      if(this.type === 'boxShadow') {
        this.attr.push({type: 'spread', name: '扩散', step: 1, min: -100, max: 100, len: 200, val: shadow.spread})
      }
      
      Object.assign(this.shadow, shadow)
    },
    selectType(item, key) {
      if(item.active || item.disable) return;
      this.typeList.forEach((val, k) => {
        val.active = false;
        k === key && (val.active = true);
      })
      this.type = item.type;
      this.initData();
    },
    showColorPicker (e, { whichPart } = {}) {
      let rect = e.target.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color',
        type: 1,
        posx : rect.left - 50,
        posy : rect.top + 30,
        whichPart,
        color: this.bgColor
      });
    },
    colorPickerInput(obj, { type }) {
      if(type === 'shadow_color' && obj.hex) {
        this.shadow.color = obj.hex;
        this.setShadow();
      }
    },
    attrChange(val, status, index, item) {
      let bol = false;

      if(status === 'start') {
        this.undoData = {
          scenesId: this.SelectScenes_Msg.id,
          scale: this.TOOL.scale,
          data: {},
          reData: []
        }
        for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
          let s = this.SelectSprites_Msg[i];
          this.undoData.reData.push({
            id: s.id,
            type: this.type,
            shadow: s[this.type] ? Object.assign({},s[this.type]) : null
          });
        }
      } else if(status === 'end') {
        bol = true;
        this.undoData.data = {
          type: this.type,
          shadow: Object.assign({}, this.shadow)
        }
      }
      this.shadow[item.type] = val;

      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        s.setShadow(this.shadow, this.type);
      }

      if (bol)  {
        eve("undo_redo", null, { type: 'setShadows', data: this.undoData})
        this.undoData = null
      }
    },
    setShadow(reset) {
      let shadow = Object.assign({}, this.shadow);
      if(reset) {
        shadow = null;
        this.shadow = {
          x: 0,
          y: 0,
          blur: 0,
          spread: 0,
          color: '#ffffff'
        }
        this.attr.forEach(v => {
          v.val = this.shadow[v.type];
        })
      }
      let undoData = {
        scenesId: this.SelectScenes_Msg.id,
        data: {
          type: this.type,
          shadow: shadow
        },
        reData: []
      }
      for(let i = 0; i < this.SelectSprites_Msg.length; i++) {
        let s = this.SelectSprites_Msg[i];
        undoData.reData.push({
          id: s.id,
          type: this.type,
          shadow: s[this.type] ? Object.assign({},s[this.type]) : null
        })
        s.setShadow(shadow, this.type);
      }
      eve("undo_redo", null, { type: 'setShadows', data: undoData})
    },
    _undoRedoHandle({type}) {
      if (type === 'setShadows') {
        this.initData();
      }
    }
  },
  components: {
    SliderSetting
  },
  beforeDestroy() {
    this.$bus.off('colorPickerInput.picker', this.colorPickerInput);
    this.$bus.off("undoRedoHandle", this._undoRedoHandle)
  }
}
</script>

<style lang="scss" scoped>
.shadow-setting {
  width: 100%;
  transition: all 0.3s;
  border-bottom: 1px solid #D4D4E7;
  overflow: hidden;
}
.shadow-setting-header {
  display: flex;
  height: 46px;
  line-height: 46px;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  color: #474261;
  cursor: pointer;

  i {
    width: 10px;
    height: 6px;
    margin-right: 10px;
    transition: all 0.3s;
  }
}
.shadow-setting-type, .shadow-setting-color {
  margin-bottom: 15px;
  display: flex;
  justify-content:space-between;
  align-items: center;
  height: 32px;

  > span {
    width: 50px;
    text-align: left;
  }

  > div {
    width: 175px;
  }
}

.shadow-setting-type .type-content {
  display: flex;

  .shadow-help {
    margin-left: 5px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    color: #fff;
    background-color: #474261;
    border-radius: 50%;
    cursor: pointer;
  }
}

.shadow-setting-color .color-content div {
  width: 36px;
  height: 24px;
  border-radius: 4px;
  background-color: #ffffff;
  cursor: pointer;
  border: 1px solid #D9DDE9;
}

.shadow-setting-slider, .shadow-setting-reset {
  margin-bottom: 15px;
}

.radios__list {
  display: flex;
  width: 125px;
  justify-content: space-between;
  align-items: center;
}
.radios__item {
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;

  &>i {
    width: 16px;
    height: 16px;
    border-radius: 16px;
    border: solid 1px #474260;
  }
  &>span {
    padding-left: 5px;
  }

  &.active>i {
    background-color: #737596;
    border-color: #737596;
    box-shadow: 0 0 0 3px #ffffff inset;
  }

  &.disable {
    cursor: not-allowed;
    opacity: .6;
  }
}

.reset-button {
  width: 100px;
  height: 33px;
  line-height: 0px;
  background-color: #F5F4F9;
}
</style>


// WEBPACK FOOTER //
// src/components/settingPanel/shadowSetting.vue